export default __webpack_public_path__ + "static/media/MM.af506bb9.svg";